module.exports = function() {
  return new Worker(__webpack_public_path__ + "7aed3b4123c708fc284e.worker.js");
};